export default {
  svgPath: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.611 2.5h10.39a1 1 0 011 1v10.389h-2V5.914l-11 11L3.585 15.5l11-11H6.61v-2z"/>
  `,
  title: 'Arrow Up Right',
  viewBox: '0 0 21 20',
};
